export default function checkForCurrentYear(year) {
  const currentYear = new Date().getFullYear();
  return year === currentYear;
}